module.exports = __webpack_public_path__ + "img/152x152.898cfdda.png";